import React, { useRef } from 'react'
import styled from 'styled-components'
import { IClientsItem } from '../../../../../modules/API/Defaults/models/customers'
import { useDetectOutsideClick } from '../../../../../generic/hooks/useDetectOutsideClick'
import SearchBlockWithTitle from '../../procedures/Q8/Layouts/SearchBlockWithTitle'
import SearchCustomers from '../../forcasts/Supply/Components/SearchCustomers'
import DatePickerISO from '../../forcasts/Distribution/Components/DatePickerISO'
import FancyButton from '../../knisotLines/Components/FancyButton'

type Props = {
  customerList: IClientsItem[]
  customerID: number
  setCustomerID: React.Dispatch<React.SetStateAction<number>>
  selectedDate: Date
  setSelectedDate: React.Dispatch<React.SetStateAction<Date>>
  onConfirm: () => void
  onClose: () => void
  isLoading: boolean
}

const QuotationInitModal: React.FC<Props> = ({
  customerList,
  customerID,
  setCustomerID,
  selectedDate,
  setSelectedDate,
  onConfirm,
  onClose,
  isLoading,
}) => {
  const modalRef = useRef<HTMLDivElement>(null)
  useDetectOutsideClick(modalRef, onClose)

  const isDisabled = customerID === 0

  return (
    <Overlay>
      <ModalCard ref={modalRef}>
        <SearchBlockWithTitle title="תאריך">
          <DatePickerISO
            selected={selectedDate}
            onChange={setSelectedDate}
          />
        </SearchBlockWithTitle>

        <SearchBlockWithTitle title="לקוח">
          <SearchCustomers
            list={customerList}
            defaultID={customerID}
            setCustomerID={setCustomerID}
            placeholder="בחר לקוח"
            required
          />
        </SearchBlockWithTitle>

        <ButtonRow>
          <FancyButton
            onClick={onConfirm}
            disabled={isDisabled}
            isLoading={isLoading}
          >
            אישור
          </FancyButton>
        </ButtonRow>
      </ModalCard>
    </Overlay>
  )
}

export default QuotationInitModal

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`

const ModalCard = styled.div`
  background: #fff;
  border-radius: 30px;
  padding: 1.5em;
  width: 90%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 1em;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
`

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 0.5em;
`
